// Feature P3: every contract carries a one-line story — why the owner rang.
// Dry, Australian, no real names or brands. Picked by a seeded draw of its
// own (never the board's rng), so adding stories moves nothing else.

import { mixSeed, mulberry32, pick } from './rng';

export const STORIES: readonly string[] = [
  'Footy finals at theirs Saturday. Half the club is coming.',
  "Nonna's 80th out the back on Sunday. She will inspect.",
  'Real estate photos Tuesday. The agent wants it looking loved.',
  'Body corporate complaint came in. Third one this month.',
  "New puppy dug up the bed. Owner's pretending it didn't.",
  'Engagement party Friday arvo. The marquee goes up at four.',
  "Tenants are moving out. The bond's riding on this.",
  'Owner is back from six weeks up north. It shows.',
  'Christening on the lawn Sunday. Nobody wants bindii in the photos.',
  'The neighbour left a note in the letterbox. Underlined twice.',
  'Council wrote about the verge. Politely, for now.',
  'Open home Saturday at ten. Every blade counts.',
  'Grandkids are down for the school holidays.',
  "Owner's hip is playing up. Usually does it himself.",
  'Wedding photos under the jacaranda next weekend.',
  "Street party Saturday. This place is doing the sausage sizzle.",
  'Settlement is Thursday. The buyer wants a final walk-through.',
  'Book club is moving outdoors. Standards are high.',
  'Wet season is over and the yard made the most of it.',
  'Owner has been overseas. The grass has not.',
  'Backyard cricket on Boxing Day. It needs a pitch.',
  "A six-year-old's birthday. Forty guests. Good luck.",
  "Landlord inspection Wednesday. The tenant's nervous.",
  'Carols in the cul-de-sac. This yard is the stage.',
  'The last mowing bloke retired. You are on trial.',
  'The chooks got out and had a go at it.',
  'Owner is selling up and moving to the coast.',
  'Family reunion Saturday. Aunties from three states.',
  'New fence went in. The builders left their mess behind.',
  'Garden club judging comes through Monday.',
  "Owner's new ride-on is on back order. You're the stopgap.",
  "Housemates can't agree whose turn it is. So, you.",
  'Grand final barbecue. The telly is going out on the deck.',
  'Owner swears it looked fine from the kitchen window.',
  'Bloke next door mows his in stripes. Match him.',
  'Council verge audit next week. The clipboards are out.',
  'Holiday-let guests land Friday. Reviews are everything.',
  'Owner ran out of weekends. Happens to the best of us.',
  'Trivia night trophy is going on display out the front. Seriously.',
  "Mother-in-law arrives Thursday. She's already said something.",
];

/**
 * The story for a contract seed: deterministic, independent of any other draw.
 * Pass the board's `taken` set to skip stories already on it (the next one in
 * the pool is used, and added to the set).
 */
export function storyFor(seed: number, taken?: Set<string>): string {
  const start = STORIES.indexOf(pick(mulberry32(mixSeed(seed, 0x5709e1)), STORIES));
  for (let k = 0; k < STORIES.length; k++) {
    const s = STORIES[(start + k) % STORIES.length];
    if (!taken?.has(s)) {
      taken?.add(s);
      return s;
    }
  }
  return STORIES[start];
}
